

















































import {Component, Vue} from "vue-property-decorator";
import DeleteButton from "@/components/datatable/DeleteButton.vue";
import EForm from "@/components/datatable/EForm.vue";
import Number from "@/components/inputs/Number.vue";
import TextField from "@/components/inputs/TextField.vue";
import Id from "@/components/inputs/Id.vue";
import SeoText from "@/components/inputs/SeoText.vue";
import Editor from '@tinymce/tinymce-vue';
import {ActionsEnum} from "@/entity/ActionsEnum";
import Seo from "@/components/inputs/Seo.vue";
import ImageUpload from "@/components/inputs/ImageUpload.vue";
import RichTextEditor from "@/components/inputs/RichTextEditor.vue";

class pages {
  page_id : Number | undefined = undefined;
  seo_id : Number | undefined = undefined;
  name : String  | undefined  = "";
  title:String | undefined ="";
  image_url:String | undefined ="";
  file!:File;
  context_data:String | undefined="";
  page_type="blog";
}
@Component({
  components: {
    RichTextEditor,
    ImageUpload,
    Seo,
    DeleteButton,EForm,Number,TextField,Id,SeoText,Editor
  }
})
export default class Blog extends  Vue{
  items : pages[] | null= null;
  dialog = false;
  title:string = "";
  search: string = "";
  baseAction:string = ActionsEnum.Blog;
  action:string = this.baseAction;
  data : pages = new pages();
  headers = [
    {
      text: "Id",
      align: "start",
      sortable: true,
      value: "page_id"
    },
    {text: "Başlık", value: "title"},
    {text: "Url", value: "name"},
    {text: "İşlemler", value: "actions"}

  ];
  /*
  TODO Sayfalar nerde konumlanacak footer vs ekle ..
      persistent ayarlari yapilacak modal belki yeni component olabilir
   */
  edit(item:pages){
    this.title = "Düzenle";
    this.data = item;
    this.action = this.baseAction + "/" + item.page_id;
    this.dialog = true;
  }
  dialogClick(e:Event){
    console.log("event",e);
    e.preventDefault();

  }
  add(){
    this.title = "Ekle";
    this.data = new pages();
    this.action = this.baseAction;
    this.dialog = true;
  }
  async get(){
    this.dialog = false;
    let response = await this.$http.get(this.baseAction);
    this.items = response.data;
  }
  created(){
    this.get();
  }
};
